/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Lecturer } from './lecturer';

export type ModuleAuthor = Lecturer | null;
